var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { AwesomeEvent, ComponentAPI } from '@philips-internal/oswald-ui-core';
import { AbortableCloseEventListener, CloseEventListener } from '@philips-internal/oswald-ui-core/lib/component/types/index.js';
class ModalAPI extends ComponentAPI {
    constructor() {
        super(...arguments);
        /** @event */
        this.onBeforeClose = new AbortableCloseEventListener();
        /** @event */
        this.onClose = new CloseEventListener();
    }
    /**
     * Closes the modal
     */
    close() {
        let close = true;
        const abort = () => { close = false; };
        this.onBeforeClose.fire({ abort });
        close && this.onClose.fire();
    }
    /**
     * Returns if the modal is closeable
     */
    isCloseable() {
        return this.state.closeable;
    }
    /**
     * Sets if the modal is closeable
     * @param closeable if the modal is closeable
     */
    setCloseable(closeable) {
        this.setState({ closeable });
    }
    /**
     * Returns if the modal is closeable by document
     */
    isCloseByDocument() {
        return this.state.closeByDocument;
    }
    /**
     * Sets if the modal is closeable by document
     * @param closeByDocument if the modal is closeable by document
     */
    setCloseByDocument(closeByDocument) {
        this.setState({ closeByDocument });
    }
    /**
     * Returns if the modal is closeable by escape key
     */
    isCloseByEscape() {
        return this.state.closeByEscape;
    }
    /**
     * Sets if the modal is closeable by escape key
     * @param closeByEscape if the modal is closeable by escape key
     */
    setCloseByEscape(closeByEscape) {
        this.setState({ closeByEscape });
    }
    /**
     * Returns if the modal does not have paddings
     */
    isNoPadding() {
        return this.state.noPadding;
    }
    /**
     * Sets if the modal does not have paddings
     * @param noPadding if the modal does not have paddings
     */
    setNoPadding(noPadding) {
        this.setState({ noPadding });
    }
    /**
     * Gets modal title
     */
    getTitle() {
        return this.state.title;
    }
    /**
     * Sets modal title
     * @param title modal title
     */
    setTitle(title) {
        this.setState({ title });
    }
    /**
     * Gets modal theme
     */
    getTheme() {
        return this.state.theme;
    }
    /**
     * Sets modal theme
     * @param theme modal theme
     */
    setTheme(theme) {
        this.setState({ theme });
    }
    /**
     * Gets modal type
     */
    getType() {
        return this.state.type;
    }
    /**
     * Sets modal type
     */
    setType(type) {
        this.setState({ type });
    }
    /**
     * Gets if the modal header is hidden on mobile
     */
    getHideHeaderOnMobile() {
        return this.state.hideHeaderOnMobile;
    }
    /**
     * Sets if the modal header is hidden on mobile
     * @param hideHeaderOnMobile if the modal header is hidden on mobile
     */
    setHideHeaderOnMobile(hideHeaderOnMobile) {
        this.setState({ hideHeaderOnMobile });
    }
}
__decorate([
    AwesomeEvent,
    __metadata("design:type", Object)
], ModalAPI.prototype, "onBeforeClose", void 0);
__decorate([
    AwesomeEvent,
    __metadata("design:type", Object)
], ModalAPI.prototype, "onClose", void 0);
export { ModalAPI, };
//# sourceMappingURL=modal-api.js.map